import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Drawer } from '@mui/material';

import { selectLayoutSlice, updateLayout } from 'store/slices/layout.slice';
import { NavList } from 'components';
import { unauthMobileHeaderMenuConfig } from 'configs';
import { useAppDispatch, useAppSelector } from 'store/store.hook';

interface UnauthSidebarMenuLayoutProps {}

export const UnauthSidebarMenuLayout: React.FC<UnauthSidebarMenuLayoutProps> = () => {
  const dispatch = useAppDispatch();
  const { unauthSidebarMenuOpened = false } = useAppSelector(selectLayoutSlice);
  const location = useLocation();

  const closeSidebar = () => {
    dispatch(
      updateLayout({
        unauthSidebarMenuOpened: false,
      }),
    );
  };

  return (
    <Drawer
      anchor="right"
      open={unauthSidebarMenuOpened}
      onClose={() => closeSidebar()}
      sx={{
        display: {
          md: 'none',
        },
      }}
    >
      <Box sx={{ minWidth: 240, bgcolor: 'background.paper' }} paddingX={2} paddingY={4}>
        <NavList
          navItems={unauthMobileHeaderMenuConfig}
          direction="column"
          activeLink={location.pathname}
          onNavItem={() => {
            closeSidebar();
          }}
        />
      </Box>
    </Drawer>
  );
};
